<!-- Seletor de estado do pedido (padrao wave — FORM_UI secao 3/4) -->
<p-dialog
  [visible]="visivel"
  (visibleChange)="!$event && fechar()"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }"
  [breakpoints]="{ '576px': '95vw' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-arrow-right-arrow-left" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts?.botoes?.estados || 'Estados' }}</h2>
        <p>{{ texts?.mensagens?.selecione_estado || 'Selecione o novo estado:' }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="estados-opcoes">
      <button *ngFor="let opcao of estadosDisponiveis()"
              type="button"
              class="estado-opcao"
              [style.border-left-color]="getCorOpcao(opcao)"
              (click)="onSelecionar(opcao)">
        <div class="estado-opcao-icon" [style.background]="getFundoOpcao(opcao)">
          <i [class]="getIconeOpcao(opcao)" aria-hidden="true"></i>
        </div>
        <span class="estado-opcao-label">{{ opcao.label }}</span>
        <i class="pi pi-chevron-right estado-opcao-arrow" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
            type="button"
            [label]="texts?.botoes?.fechar"
            class="p-button-secondary"
            (click)="fechar()">
    </button>
  </ng-template>
</p-dialog>
